import {Pipe, PipeTransform} from '@angular/core';
import {Option, toUndefined} from 'fp-ts/lib/Option';

@Pipe({
  name: 'option',
  standalone: true,
})
export class OptionPipe implements PipeTransform {
  transform<A>(val: Option<A>): A | undefined {
    if (!val) {
      return undefined;
    }
    return toUndefined(val);
  }
}
